

export class DeviceModelSpecificationStatusInput implements IDeviceModelSpecificationStatusInput {
    /** The auto-generated id of the device model port specification master */
    deviceModelPortSpecificationId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IDeviceModelSpecificationStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceModelPortSpecificationId = _data["deviceModelPortSpecificationId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): DeviceModelSpecificationStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceModelSpecificationStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceModelPortSpecificationId"] = this.deviceModelPortSpecificationId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IDeviceModelSpecificationStatusInput {
    /** The auto-generated id of the device model port specification master */
    deviceModelPortSpecificationId: number;
    /** The updated status */
    status: number;
}

